import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { FaBullhorn, FaStar } from "react-icons/fa";
import logo from "../../assets/Logo.svg";
import "./NewFeaturesModal.css";

const FEATURES = [
    {
        key: "ai-search",
        title: "Búsqueda con IA",
        description:
            "Describí lo que necesitás en tus propias palabras. La IA encuentra los proveedores y servicios más relevantes para vos.",
        mark: (
            <span className="nf-mark nf-mark--ai" aria-hidden="true">
                <span className="nf-mark__ia-text">IA</span>
            </span>
        ),
    },
    {
        key: "posts",
        title: "Posteá lo que necesitás",
        description:
            "Publicá tu pedido y dejá que los profesionales te contacten a vos. Una nueva forma de conectar con la comunidad.",
        mark: (
            <span className="nf-mark nf-mark--posts" aria-hidden="true">
                <FaBullhorn />
            </span>
        ),
    },
    {
        key: "ratings",
        title: "Calificaciones",
        description:
            "Valorá a los proveedores con los que trabajaste y elegí mejor gracias a las opiniones de la comunidad.",
        mark: (
            <span className="nf-mark nf-mark--ratings" aria-hidden="true">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
            </span>
        ),
    },
];

const NewFeaturesModal = ({ isOpen, onClose, onExplore }) => {
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        if (!isOpen) return;
        const handleKey = (e) => {
            if (e.key === "Escape") handleClose();
        };
        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setIsClosing(false);
            onClose?.();
        }, 200);
    };

    const handleBackdropClick = (e) => {
        if (e.target.classList.contains("nf-modal-backdrop")) {
            handleClose();
        }
    };

    const handleExplore = () => {
        onExplore?.();
        handleClose();
    };

    if (!isOpen) return null;

    return (
        <div
            className={`nf-modal-backdrop ${isClosing ? "nf-modal-closing" : ""}`}
            onClick={handleBackdropClick}
            role="dialog"
            aria-modal="true"
            aria-labelledby="nf-modal-title"
        >
            <div className="nf-modal-paper">
                <button
                    className="nf-modal-close"
                    onClick={handleClose}
                    aria-label="Cerrar"
                    type="button"
                >
                    <X size={20} />
                </button>

                <header className="nf-modal-head">
                    <h2 id="nf-modal-title" className="nf-modal-headline">
                        <span className="nf-modal-headline-line">Lo nuevo en</span>
                        <span className="nf-modal-brand">
                            <img
                                src={logo}
                                alt=""
                                aria-hidden="true"
                                className="nf-modal-brand-logo"
                            />
                            <span className="nf-modal-brand-text">NTACTAME</span>
                        </span>
                        <span className="nf-modal-sr">CONTACTAME</span>
                    </h2>
                </header>

                <ol className="nf-modal-list">
                    {FEATURES.map((feature, index) => (
                        <li
                            key={feature.key}
                            className="nf-modal-item"
                            style={{ animationDelay: `${0.08 + index * 0.07}s` }}
                        >
                            <span className="nf-modal-num" aria-hidden="true">
                                {index + 1}
                            </span>
                            <div className="nf-modal-item-body">
                                <div className="nf-modal-item-titlebar">
                                    {feature.mark}
                                    <h3 className="nf-modal-item-title">{feature.title}</h3>
                                </div>
                                <p className="nf-modal-item-desc">{feature.description}</p>
                            </div>
                        </li>
                    ))}
                </ol>

                <div className="nf-modal-foot">
                    <button
                        type="button"
                        className="nf-modal-cta"
                        onClick={handleExplore}
                    >
                        Quiero ver
                        <span className="nf-modal-cta-arrow" aria-hidden="true">→</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NewFeaturesModal;
